import * as React from 'react';
import S from './InnerHeroBanner.styles';
import ImageMask from '@stories/Components/Global/ImageMask/ImageMask';
import { getSrcs } from '@helpers/image';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import Breadcrumb from '@stories/Components/Global/Breadcrumb/Breadcrumb';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
const InnerHeroBanner = ({ breadcrumb, cta1, cta2, image, intro, title, titleTheme = 'gradient', theme = 'orange', }) => {
    const srcs = getSrcs(image, 800, 457, 8, 4 / 7);
    return (React.createElement(S.Container, { "data-theme": theme },
        React.createElement(S.ShapeTopLeft, null),
        React.createElement(S.ShapeBottomRight, null),
        React.createElement(SectionWrapper, null,
            React.createElement(S.Grid, null,
                breadcrumb && (React.createElement(S.BreadCrumbArea, null,
                    React.createElement(Breadcrumb, { items: breadcrumb.items }))),
                React.createElement(S.ContentArea, null,
                    React.createElement(S.Title, { "data-title-theme": titleTheme }, title),
                    React.createElement(S.Intro, { dangerouslySetInnerHTML: { __html: intro } }),
                    React.createElement(S.CtaArea, null,
                        cta1?.url && (React.createElement(LinkButton, { branding: cta1?.branding ?? 'red', styleType: "solid", title: cta1?.text || 'Find out more', href: cta1?.url, target: cta1?.target ?? '_self', addon: cta1.icon
                                ? getSvgFromSystem(cta1.icon)
                                : getSvgFromSystem(SystemIcon.ArrowRight), addonPosition: "left" })),
                        cta2?.url && (React.createElement(LinkButton, { branding: cta2?.branding ?? 'red', styleType: "outline", title: cta2?.text || 'Find out more', href: cta2?.url, target: cta2?.target ?? '_self', addon: cta2.icon
                                ? getSvgFromSystem(cta2.icon)
                                : getSvgFromSystem(SystemIcon.ArrowRight), addonPosition: "left" })))),
                image.src && (React.createElement(S.MediaArea, null,
                    React.createElement(S.MediaHolder, null,
                        React.createElement(S.ShapeShadow, null),
                        React.createElement(ImageMask, { mask: 'hexagon-squash' },
                            React.createElement(S.Image, { alt: image.altText || '', loading: "eager", role: image.altText ? undefined : 'presentation', src: srcs[0], srcSet: srcs.join(','), width: "700", height: "400" }),
                            React.createElement(S.BurnOverlay, null)))))))));
};
export default InnerHeroBanner;
